module.exports = __webpack_public_path__ + "static/media/ReactNucamp.23d3a4d4.png";